import React from 'react';
import { Image, Tag } from 'antd';
import getSearchFilterByName from '../helpers/getSearchFilterByName';
import { getDateAndTime } from '../helpers/getDate';
import getFiltersDropdown from '../helpers/getFiltersDropdown';
import getRangeDateDropdown from '../helpers/getRangeDateDropdown';
import { useSelector } from 'react-redux';
import getFiltersRangeInputs from '../helpers/getFiltersRangeInputs';
import {getFallbackImage, insert} from '../helpers/helpers';
import { getUseSelectorFromType } from '../helpers/getUseSelectorFromType';
import {CheckCircleOutlined, CloseCircleOutlined, DragOutlined } from '@ant-design/icons';

export const dashboardColumns = ({type, orderRender}) => {
	let useSelectorType, sortingFiltersType, tableFiltersType, sortingFilters, tableFilters, warehouseIds;
	const {warehouses} = useSelector(state => state?.warehouses)
	const {sites} = useSelector(state => state?.sites)

	if (type !== 'pick-lists') {
		useSelectorType = getUseSelectorFromType(type);
		sortingFiltersType = useSelectorType + 'TableSorting';
		tableFiltersType = useSelectorType + 'TableFilters';
		sortingFilters = useSelector(state => state[useSelectorType][sortingFiltersType])
		tableFilters = useSelector(state => state[useSelectorType][tableFiltersType])
		warehouseIds = useSelector(state => {
			return state[ useSelectorType ]?.siteAndWarehousesFilters?.warehouse_ids ?
				state[ useSelectorType ]?.siteAndWarehousesFilters?.warehouse_ids :
				state.warehouses?.warehouses?.objects?.reduce( ( acc, item ) => {
					acc.push( item.id );
					return acc;
				}, [] ).join( ',' );
		} )
	} else {
		sortingFiltersType = 'pickListsTableSorting';
		sortingFilters = useSelector(state => state?.picklist[sortingFiltersType]);
	}

	const columns = {
		attributesColumns: [
			{
				title: 'Namn',
				dataIndex: 'name',
				...getSearchFilterByName({type: 'attributes', tableFilters, dataIndex: 'name', placeholder: 'Sök efter namn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'name' ? sortingFilters?.order: null
			},
			{
				title: 'Värden',
				dataIndex: 'values',
				render: (_, record) => {
					return record.values.map(val => val).join(', ')
				},
			},
		],
		upsellObjectsColumns: [
			{
				title: 'Försäljningställe',
				dataIndex: 'site_id',
				sorter: () => false,
				render: (_, upsellObject) => {
					console.log(sites)
					const currentSite = sites?.objects?.find(_site => _site.id === upsellObject.site_id);
					return currentSite && currentSite.name
				},
				sortOrder: sortingFilters?.column?.dataIndex === 'site_id' ? sortingFilters?.order: null
			}
		],
		productsColumns: [
			{
				title: 'Utvald bild',
				dataIndex: 'featured_image',
				render: (_, product) => {
					return <Image width={120} src={ (!product.featured_image || !product.featured_image.url) ? getFallbackImage() : product.featured_image.url}/>
				}
			},
			{
				title: 'Order id',
				dataIndex: 'order_id',
				className: 'order_id',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'order_id' ? sortingFilters?.order: null
			},
			{
				title: 'SKU',
				dataIndex: 'sku',
				editable: true,
				responsive: ['md'],
				...getSearchFilterByName({dataIndex: 'sku', type: 'products', tableFilters, placeholder: 'Sök efter artikelnummer'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'sku' ? sortingFilters?.order: null
			},
			{
				title: 'Benämning',
				dataIndex: 'title',
				editable: true,
				...getSearchFilterByName({dataIndex: 'title', type: 'products', tableFilters, placeholderText:'Sök efter produktnamn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'title' ? sortingFilters?.order: null
			},
			{
				title: 'Synlighet i katalogvy',
				editable: true,
				dataIndex: 'catalog_visibility',
				type: 'select',
				options: [
					{
						value: 'Synlig',
						key: 'visible'
					},
					{
						value: 'Katalog',
						key: 'catalog'
					},
					{
						value: 'Gömd',
						key: 'hidden'
					},
					{
						value: 'Sök',
						key: 'search'
					}
				],
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'catalog_visibility' ? sortingFilters?.order: null
			},
			{
				title: 'Kategorier',
				dataIndex: 'categories',
				...getFiltersDropdown({dataIndex: 'categories', isCustomSelect: true, customSelectMode: 'single', type: 'products', fetchType: 'categories', values: null, filterText: 'Sök efter kategorinamn'}),
				render: (_, product) => {
					let categories = product.categories.map(item => {
						return item.name
					})
					return categories.join(', ')
				},
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'categories' ? sortingFilters?.order: null
			},
			{
				title: 'Pris',
				dataIndex: 'price',
				editable: true,
				type: 'number',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'price' ? sortingFilters?.order: null
			},
			{
				title: 'REA-pris',
				dataIndex: 'sales_price',
				editable: true,
				type: 'number',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'sales_price' ? sortingFilters?.order: null
			},
			{
				title: 'Försäljningsställen',
				dataIndex: 'sites',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'sites' ? sortingFilters?.order: null,
				render: (_, product) => product?.external_products?.length > 0 && product?.external_products?.map(site => site.site_name).join(', ')
			},
			{
				title: 'Skapad',
				dataIndex: 'datetime_created',
				render: (_, product) => {
					return getDateAndTime(product.datetime_created)
				},
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'datetime_created' ? sortingFilters?.order: null
			},
			{
				title: 'Uppdaterad',
				dataIndex: 'datetime_last_updated',
				render: (_, product) => {
					return getDateAndTime(product.datetime_last_updated)
				},
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'datetime_last_updated' ? sortingFilters?.order: null
			}

		],
		categoriesColumns: [
			{
				title: 'Utvald bild',
				dataIndex: 'featured_image',
				render: (_, category) => {
					return <Image width={120} src={ (!category.featured_image || !category.featured_image.url) ? getFallbackImage() : category.featured_image.url}/>
				}
			},
			{
				title: 'Namn',
				dataIndex: 'name',
				...getSearchFilterByName({dataIndex: 'name', type: 'categories', tableFilters, placeholder: 'Sök efter namn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'name' ? sortingFilters?.order: null
			},
			{
				title: 'Bekrivning',
				dataIndex: 'description',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'description' ? sortingFilters?.order: null,
				...getSearchFilterByName({dataIndex: 'description', type: 'categories', tableFilters, placeholderText:'Sök efter kategoribeskrivning'}),
			},
			{
				title: 'Förälder',
				dataIndex: 'parent_id',
				render: (_, record) => {
					if (record.parent_id) {
						return <div>{record.parent_id.name}</div>
					}
				},
				...getFiltersDropdown({dataIndex: 'parent_id', customSelectMode: 'single', isCustomSelect: true, type: 'categories', fetchType: 'categories', values: null, filterText: 'Förälder filter'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'parent_id' ? sortingFilters?.order: null,
			},
		],
		imagesColumns: [
			// {
			// 	title: 'Bild',
			// 	dataIndex: 'url',
			// 	render: (_, record) => {
			// 		return (
			// 			<Image
			// 				width={50}
			// 				fallback="data:image/png;base64,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"
			// 				src={record.url}
			// 			/>
			// 		)
			// 	},
			// },
			// {
			// 	title: 'Titel',
			// 	dataIndex: 'title',
			// 	...getSearchFilterByName({dataIndex: 'title', type: 'images', tableFilters, placeholder: 'Sök efter titel'}),
			// 	sorter: () => false,
			// 	sortOrder: sortingFilters?.column?.dataIndex === 'title' ? sortingFilters?.order: null,
			// },
			// {
			// 	title: 'Alternativ text',
			// 	...getSearchFilterByName({dataIndex: 'alt_text', type: 'images', tableFilters, placeholderText: 'Type alternativ text'}),
			// 	dataIndex: 'alt_text'
			// },
			// {
			// 	title: 'Beskrivning',
			// 	dataIndex: 'description',
			// 	...getSearchFilterByName({dataIndex: 'description', type: 'images', tableFilters, placeholderText: 'Type beskrivning'}),
			// },
			// {
			// 	title: 'Bildtext',
			// 	dataIndex: 'caption',
			// 	...getSearchFilterByName({dataIndex: 'caption', type: 'images', tableFilters, placeholderText: 'Ange bildtext'}),
			// 	sorter: () => false,
			// 	sortOrder: sortingFilters?.column?.dataIndex === 'caption' ? sortingFilters?.order: null,
			// },
			// {
			// 	title: 'Uppladdad',
			// 	dataIndex: 'date_created',
			// 	render: (_, image) => image.date_created ? getDateAndTime(image.date_created) : '',
			// 	...getRangeDateDropdown({dataIndex: 'date_created', tableFilters}),
			// 	sorter: () => false,
			// 	sortOrder: sortingFilters?.column?.dataIndex === 'date_created' ? sortingFilters?.order: null,
			// }
		],
		ordersColumns: [
			{
				title: 'Ordernummer',
				dataIndex: 'order_number',
				...getSearchFilterByName({dataIndex: 'order_number', type: 'orders', tableFilters, placeholderText: 'Sök efter ordernummer', isNumber: true}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'order_number' ? sortingFilters?.order: null,
			},
			{
				title: 'Datum',
				dataIndex: 'datetime_created',
				render: (_, order) => getDateAndTime(order.datetime_created),
				...getRangeDateDropdown({dataIndex: 'datetime_created', tableFilters}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'datetime_created' ? sortingFilters?.order: null,
			},
			{
				title: 'Kundens namn',
				dataIndex: 'customer_first_name',
				render: (_, order) => `${order?.customer?.billing_first_name}`,
				...getSearchFilterByName({dataIndex: 'customer_first_name', type: 'orders', tableFilters, placeholderText: 'Sök efter kundens namn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'customer_first_name' ? sortingFilters?.order: null,
			},
			{
				title: 'Kundens efternamn',
				dataIndex: 'customer_last_name',
				render: (_, order) => `${order?.customer?.billing_last_name}`,
				...getSearchFilterByName({dataIndex: 'customer_last_name', type: 'orders', tableFilters, placeholderText: 'Sök efter kundens efternamn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'customer_last_name' ? sortingFilters?.order: null,
			},
			{
				title: 'Leveransdag',
				dataIndex: 'delivery_date',
				render: (_, order) => order.delivery_date ? getDateAndTime(order.delivery_date) : '',
				...getRangeDateDropdown({dataIndex: 'delivery_date', tableFilters, from: 'delivery_date_from', to: 'delivery_date_to' }),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'delivery_date' ? sortingFilters?.order: null,
			},
			{
				title: 'Status',
				dataIndex: 'status',
				...getFiltersDropdown({values:  [
						{text: 'Behandlas', value: 'processing'},
						{text: 'Avbruten', value: 'cancelled'},
						{text: 'Färdigbehandlad', value: 'completed'},
				], dataIndex: 'status', type: 'orders'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'status' ? sortingFilters?.order: null,
			},
			{
				title: 'Trivec',
				dataIndex: 'synchronized_to_trivec',
				...getFiltersDropdown({values:  [
						{text: 'Synkroniserad', value: 'synchronized'},
						{text: 'FEL', value: 'error'},
					], dataIndex: 'synchronized_to_trivec', type: 'orders'}),
				render: (_, order) => {
					const foundTrivec = order?.order_meta?.find(item => item.meta_key === 'synchronized_to_trivec')

					if (foundTrivec) {
						const isSync = foundTrivec.meta_value === 'synchronized',
							isError = foundTrivec.meta_value === 'error';

						return isSync ?
							<div style={{textAlign: 'center'}}><CheckCircleOutlined style={{color: '#52c41a', margin: '0 auto'}}/></div> :
							( isError ?
									<div style={{textAlign: 'center'}}><CloseCircleOutlined style={{color: '#ff4d4f'}}/></div> :
									( !foundTrivec.meta_value && '' )
							)
					}
				}
			},
			{
				title: 'Site',
				dataIndex: 'site_id',
				render: (_, order) => order.site && order.site.name,
				...getFiltersDropdown({
					dataIndex: 'site_id',
					type: 'orders',
					isCustomSelect: true,
					customSelectMode: 'single',
					optionValue: 'id',
					fetchType: 'sites'
				})
			},
			{
				title: 'Total',
				dataIndex: 'total',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'total' ? sortingFilters?.order: null,
			},
			{
				title: 'Betalmetod',
				dataIndex: 'payment_method_name',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'payment_method_name' ? sortingFilters?.order: null,
			},
			{
				title: 'Fraktmetod',
				dataIndex: 'shipping_method_machine_name',
                render: (_, order) => {
                  return order?.shipping_method_name
                },
				...getFiltersDropdown({
					type: 'orders',
					isCustomSelect: true,
					customSelectMode: 'single',
					dataIndex: 'shipping_method_machine_name',
					optionValue: 'machine_name',
					optionName: 'name',
					fetchType: 'shipping_methods',
					filterText: 'shipping method'
				}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'shipping_method_machine_name' ? sortingFilters?.order: null,
			}
		],
		shippingBaseAddressesColumns: [
			{
				title: 'Namn',
				dataIndex: 'name'
			},
			{
				title: 'Adress',
				dataIndex: 'address'
			},
			{
				title: 'Ort',
				dataIndex: 'city'
			},
			{
				title: 'Land',
				dataIndex: 'country'
			},
			{
				title: 'Epost',
				dataIndex: 'email'
			},
			{
				title: 'Telefon',
				dataIndex: 'phone'
			},
		],
		shippingClassesColumns: [
			{
				title: 'Försäljningsställen',
				dataIndex: 'site_id',
				render: (_, site) => {
					const currentSite = sites?.objects?.find(_site => _site.id === site.site_id);
					return currentSite && currentSite.name
				}
			},
			{
				title: 'Namn',
				dataIndex: 'name'
			}
		],
		shippingMethodsColumns: [
			{
				title: 'Namn',
				dataIndex: 'name'
			},
			{
				title: 'Aktiv',
				dataIndex: 'enabled',
				render: (_, record) => {
					if (record.enabled) {
						return <div>Ja</div>
					}
					else{
						return <div>Nej</div>
					}
				},
			},
			{
				title: 'Lagerställe',
				dataIndex: 'warehouse_name',
				render: (_, shippingMethod) => shippingMethod.warehouse && shippingMethod.warehouse.name
			},
			{
				title: 'Försäljningsställen',
				dataIndex: 'site_id',
				render: (_, site) => {
					const currentSite = sites?.objects?.find(_site => _site.id === site.site_id);
					return currentSite && currentSite.name
				}
			},
		],
		sitesColumns: [
			{
				title: 'ID',
				dataIndex: 'id'
			},
			{
				title: 'Namn',
				dataIndex: 'name'
			},
		],
		stockObjectsColumns: [
			{
				title: 'SKU',
				dataIndex: 'sku',
				...getSearchFilterByName({dataIndex: 'sku', type: 'stock_objects', tableFilters, placeholderText: 'Sök efter artikelnummer'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'sku' ? sortingFilters?.order: null,
			},
			{
				title: 'Namn',
				dataIndex: 'product_name',
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'product_name' ? sortingFilters?.order: null,
				...getSearchFilterByName({dataIndex: 'name', type: 'stock_objects', tableFilters, placeholderText: 'Sök efter namn'}),
			},
			{
				title: 'Disponibelt lager',
				editable: true,
				type: 'number',
				dataIndex: 'disposable_quantity',
				...getFiltersRangeInputs({dataIndex: 'disposable_quantity', tableFilters, filterText: 'disponibelt lager'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'disposable_quantity' ? sortingFilters?.order: null,
			},
			{
				title: 'Lagerställe',
				dataIndex: 'warehouse_name',
				render: (_, stockObject) => stockObject.warehouse && stockObject.warehouse.name
			},
		],
		tagsColumns: [
			{
				title: 'Namn',
				dataIndex: 'name',
				...getSearchFilterByName({dataIndex: 'name', type: 'tags', tableFilters, placeholderText: 'Sök efter namn'}),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'name' ? sortingFilters?.order: null,
			}
		],
		picklistColumns: [
			{
				title: 'Leveransdag',
				dataIndex: 'delivery_date',
				render: (_, order) => getDateAndTime(order.delivery_date),
				sorter: () => false,
				sortOrder: sortingFilters?.column?.dataIndex === 'delivery_date' ? sortingFilters?.order: null,
			},
			{
				title: 'Datum',
				dataIndex: 'datetime_created',
				render: (_, order) => getDateAndTime(order.datetime_created)
			},
			{
				title: 'Ordernummer',
				dataIndex: 'order_number',
				render: (_, order) => orderRender(order)
			},
			{
				title: 'Kundens namn',
				dataIndex: 'customer_first_name',
				render: (_, order) => `${order?.customer?.shipping_first_name}`
			},
			{
				title: 'Kundens efternamn',
				dataIndex: 'customer_last_name',
				render: (_, order) => `${order?.customer?.shipping_last_name}`
			},
			{
				title: 'Packstatus',
				dataIndex: 'packing_status',
				render: (_, order) => {
					if (order.packing_status) {
						const statusTitle = order.packing_status.replaceAll('_', ' ');

						if (order.packing_status === 'not_packed') {
							return <Tag color="volcano">{statusTitle}</Tag>
						} else {
							return <Tag color="green">{statusTitle}</Tag>
						}
					} else {
						return '';
					}
				}
			},
			{
				title: 'Antal produkter',
				dataIndex: 'total_items',
				render: (_, order) => {
					if (order.order_items && order.order_items.length > 0) {
						return order.order_items.reduce((prev, item) => +prev + +item.quantity, 0)
					}
					return order.total_items;
				}
			},
			{
				title: 'Pris',
				dataIndex: 'total'
			},
			{
				title: 'Fraktsätt',
				dataIndex: 'shipping_method_name'
			},
		],
		picklistTotalProductsColumns: [
			{
				title: 'Produkt',
				dataIndex: 'name'
			},
			{
				title: 'Antal',
				dataIndex: 'quantity'
			},
		],
		picklistTotalDeliveryColumns: [
			{
				title: 'Leveranssätt',
				dataIndex: 'name'
			},
			{
				title: 'Antal',
				dataIndex: 'count'
			},
		]
	}

	if ( warehouseIds ) {
		const warehouseColumns = [];
		warehouseIds = warehouseIds.split(',');
		warehouseIds.forEach( id => {
			const warehouse = warehouses?.objects?.find( wh => wh?.id?.toString() === id );
			if ( warehouse ) {
				warehouseColumns.push({
					title: warehouse.name,
					dataIndex: 'disposable_quantity_' + id,
					editable: true,
					type: 'number',
					render: (_, product) => product?.disposable_quantities?.reduce( ( acc, item ) => {
						return item?.warehouse_id?.toString() === id ? acc + item?.disposable_quantity : acc
					}, 0 ),
				})
			}
		})

		const index = columns.productsColumns.findIndex( item => item.dataIndex === 'sites' );
		if ( index ) {
			columns.productsColumns.splice( index, 0, ...warehouseColumns )
		}
	}

	if (sortingFilters?.order &&
		sortingFilters?.field &&
		sortingFilters?.field === 'order_id') {
		columns.productsColumns = insert(columns.productsColumns, 0, {
			title: 'Sort',
			dataIndex: 'sort',
			width: 30,
			render: () => <DragOutlined className="draggable" style={{cursor: 'grab'}} type="swap" />,
		})

		columns.productsColumns?.map(col => {
			if (col.sorter) {
				col.sorter = false
			}

			return col;
		})
	}

	return columns;
}


